"use client"

interface RoomSizeSelectorProps {
  selectedSize: string
  onSelect: (size: string) => void
}

const roomSizes = [
  { id: "extra-small", label: "XS", description: "< 100 sq ft" },
  { id: "small", label: "Small", description: "100-200 sq ft" },
  { id: "medium", label: "Medium", description: "200-300 sq ft" },
  { id: "large", label: "Large", description: "300-400 sq ft" },
  { id: "extra-large", label: "XL", description: "> 400 sq ft" },
]

export function RoomSizeSelector({ selectedSize, onSelect }: RoomSizeSelectorProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Select Room Size</h2>
      <div className="flex flex-wrap gap-4 justify-center">
        {roomSizes.map((size) => (
          <div
            key={size.id}
            className={`flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors ${
              selectedSize === size.id
                ? "border-[#40A1AB] bg-[#40A1AB]/10"
                : "border-gray-200 hover:border-[#40A1AB]/50"
            }`}
            onClick={() => onSelect(size.id)}
          >
            <span className="text-lg font-medium">{size.label}</span>
            <span className="text-sm text-gray-500">{size.description}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
